import { HttpInterceptor, HttpRequest, HttpHandler, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { DATOS_API } from "./auth.datos";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const authToken = this.authService.getToken();
    const authTokenVersion = this.authService.getTokenVersion();

    let url1 = req.url;
    let url2 = req.urlWithParams;
    if(localStorage.getItem('customDom')){
      let dominioDef = DATOS_API.url.split("/");
      url1 = url1.replace(DATOS_API.url,`${dominioDef[0]}//${localStorage.getItem('customDom')}`);
      url2 = url2.replace(DATOS_API.url,`${dominioDef[0]}//${localStorage.getItem('customDom')}`);
    }
    // console.log("req:",req);
    const authRequest= req.clone({
      headers: this.tokenHeaders(req.headers, authToken, authTokenVersion),
      url: url1
    });
    return next.handle(authRequest);
  }

  tokenHeaders(headers: HttpHeaders, authToken: string, authTokenVersion: string): HttpHeaders {
    // console.log("authtoken:",authToken," | authtokenver:",authTokenVersion);
    headers = headers.append('Authorization', "bearer " + authToken);
    headers = headers.append('tokenactualizacion', "" + authTokenVersion);
    return headers;
  }
}
